import { Box, BoxProps, LinearProgress } from '@material-ui/core';
import React from 'react';

export interface LoadingIndicatorProps {
  isLoading?: boolean;
}

const LoadingIndicator: React.VFC<
  LoadingIndicatorProps & Pick<BoxProps, 'height'>
> = ({ isLoading = false, height = 4 }) => (
  <Box height={height} display="flex" flexDirection="column">
    {isLoading && (
      <LinearProgress
        variant="query"
        color="primary"
        style={{
          flex: '1 1 0%',
          backgroundColor: 'transparent',
          opacity: 0.3
        }}
      />
    )}
  </Box>
);

export default LoadingIndicator;
